
enum CandidateSituationProfileArrangementEnum {
    TwoColumns = 'TwoColumns',
    ThreeColumns = 'ThreeColumns'
}

export default CandidateSituationProfileArrangementEnum
